import React, { useState } from 'react';
import { PAYMENT_PROOF_OPTIONS, showError, showSuccess } from 'utils';
import styles from '../RefundItemsModal/index.module.scss';
import { payForWaitingForPaymentOrder, updatePaymentProof } from 'services';
import { Loading } from 'components/loading/Loading';
import SavedPaymentMethods from 'components/SavedPaymentMethods';
import { IMakePayment } from '../../interfaces/makePaymentModal';
import DropDown from 'components/FormFields/dropdown';
import ImageUploadComponent from 'components/ImageUploadComponent';

const MakePaymentModal = (props: IMakePayment) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [paymentProof, setPaymentProof] = useState<string>('');
  const [paymentProofImage, setPaymentProofImage] = useState<string>('');
  const [selectedPayment, setSelectedPayment] = useState<string>('');
  const { orderId, onSuccess, toggleModal, isPaid, userId } = props;

  const onSubmit = async () => {
    setLoading(true);
    try {
      if(isPaid){
        if(!paymentProof){
          throw 'Please select a payment proof.';
        }
        if(!paymentProofImage){
          throw 'Payment Proof Image Is Required.';
        }
        await updatePaymentProof(orderId, paymentProof, paymentProofImage);
        showSuccess('Payment Proof updated successfully');
      }else{
        await payForWaitingForPaymentOrder(orderId, selectedPayment);
        showSuccess('Payment has been made successfully');
      }
      onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const getPaymentProofInput = () =>(
    <>
      <div className={styles['image-section']}>
        <div className={styles['image-container']}>
          <ImageUploadComponent 
            src={paymentProofImage}
            uploadAPI={(id, image: any)=> setPaymentProofImage(image.url())} 
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            toggleModal={() => { }}
          />
        </div>
      </div>
      <div className={styles['input-section']}>
        <DropDown title="Payment Proof" value={paymentProof} onChange={setPaymentProof} options={PAYMENT_PROOF_OPTIONS} containerClass={'form-select'}/>
      </div>
    </>
  );

  const getPaymentMethods = () => {
    return (
      <div className={styles['items-section']}>
        <div className={styles['item-detail-group']}>
          <div className={styles['label']}>Select a payment method </div>
          <SavedPaymentMethods
            user={{ objectId: userId }}
            disabled={false}
            selectedPaymentId={selectedPayment}
            setPaymentId={val => setSelectedPayment(val)}
          />
        </div>
      </div>
    );
  };

  return (
    <div className={styles['main-container']}>
      {loading && <Loading />}
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['modal-title']}>
              {`${isPaid ? 'Mark Payment' : 'Make Payment'} - ${orderId}`}
            </div>
          </div>
          <i className={'fa fa-times'} onClick={()=>toggleModal()} />
        </div>
        <div className={styles['modal-body']}>
          {isPaid? getPaymentProofInput(): getPaymentMethods()}
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={()=>toggleModal()}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default MakePaymentModal;
